import axios from "axios";

const getInstance = async (file) => {
  const baseURL = "https://api-coffee-vcireba-hxe6g4b8f5aqd8ep.eastus-01.azurewebsites.net";
  // const baseURL = "http://localhost:1337";
  
  const timeout = 120000;
  // console.log(localStorage.getItem("buffalo_admin"))
  const request = axios.create({
    baseURL,
    timeout,
    headers: {
      "Content-Type": file ? "multipart/form-data" : "application/json",
      country: "sv",
    },
  });

  request.interceptors.request.use(
    async (config) => {
      const token = localStorage.getItem("buffalo_admin");
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
  return request;
};

export default getInstance;
